export default "__VITE_ASSET__C3npUm$e__";